import LegalDocument from "../components/LegalDocument";
import statement2257Content from "../content/statement2257";

export default function Statement2257() {
  return (
    <LegalDocument
      pageTitle="18 U.S.C. §2257 Statement"
      content={statement2257Content}
    />
  );
}
